/* eslint-disable import/no-anonymous-default-export */
import axios, { AxiosError } from "axios";
import useApi, { ActionResult, Api, Model, Query } from "../common/hooks/useApi"

export interface Evento extends Model {
    Nombre: string,
    Usuario: {
        UserName: string,
        NormalizedUserName: string,
        Nombre:string,
        Apellido:string,
    }
    UsuarioId: number
};

const module = "Evento";

export default () => {
    const api = useApi({ module });

    return {
        list: (query: Query) => api.list!<Evento>(query),
        save: (data: Partial<Evento>) => api.save!<Partial<Evento>, Evento>(data),
        delete: (id: number) => api.delete(id),
    }
}